var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',_vm._b({directives:[{name:"mask",rawName:"v-mask",value:(_vm.mask),expression:"mask"}],ref:"binput",attrs:{"value":_vm.value}},'b-form-input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }